/* eslint-disable camelcase */
import { Component } from 'react';
import { checkPermission } from '../../common/guards/can';
import PerformanceBar from './performance-bar';
import t from '../../../data/translations';
import { currentUserGroup } from '../../../utils/tokenUtils';


class PerformanceDetails extends Component {
  pointsPerPackIsVisible = () => {
    if (currentUserGroup() !== 'staff') {
      return true;
    }

    return checkPermission('view', 'objective_performance');
  }

  incentiveIsBaseTarget = () => {
    const { incentive } = this.props;

    return incentive.kind === 'base_target';
  }

  hasReachedTarget() {
    const { incentive } = this.props;

    return incentive.packs_sold >= incentive.target;
  }

  pointsPerPack() {
    const { incentive } = this.props;

    if (this.hasReachedTarget()) {
      return incentive.points_after_target;
    }

    if (this.incentiveIsBaseTarget() && incentive.packs_sold >= incentive.base_target) {
      return incentive.points_to_target_2;
    }

    return incentive.points_to_target;
  }

  render() {
    const { incentive, correct_to_date } = this.props;

    return (
      <div className={`performance-details ${this.hasReachedTarget() ? 'reached-target' : ''}`}>
        {this.pointsPerPackIsVisible() && (
          <div className="points-per-pack">
            {t('pointsPerPack')}
            <br />
            <strong>{this.pointsPerPack()}</strong>
          </div>
        )}
        <div>Date correct as of {correct_to_date}</div>
        <div className="clear-fix"></div>
        <PerformanceBar incentive={incentive} />
      </div>
    );
  }
}

export default PerformanceDetails;
